import {
    MOVE_TO_ANOTHER_GATEWAY,
    MOVE_TO_ANOTHER_GATEWAY_REQUEST,
    VALIDATE_GATEWAY_ASSET,
    VALIDATE_GATEWAY_ASSET_REQUEST,
    CLEAR_VALIDATE_GATEWAY_ASSET_STATE
} from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
export const getAssetMoveToAnotherGatewayAction = getApiActionCreator(MOVE_TO_ANOTHER_GATEWAY);
export const getAssetValidationGatewayAction = getApiActionCreator(VALIDATE_GATEWAY_ASSET);
export const moveToAnotherGatewayRequest = (driveSerialNumber, gatewaySerialNumber, driveAddress, gatewayId, onResetAssetInfo) => ({
    type: MOVE_TO_ANOTHER_GATEWAY_REQUEST,
    driveSerialNumber,
    gatewaySerialNumber,
    driveAddress,
    gatewayId,
    onResetAssetInfo
});
export const validateGatewayAssetRequest = (driveSerialNumber, gatewaySerialNumber, driveAddress) => ({
    type: VALIDATE_GATEWAY_ASSET_REQUEST,
    driveSerialNumber,
    gatewaySerialNumber,
    driveAddress
});
export const clearValidateGatewayAssetState = () => ({
    type: CLEAR_VALIDATE_GATEWAY_ASSET_STATE
});
